import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function ResetPassword() {
  const navigate = useNavigate();
  const { uid, token } = useParams();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!newPassword || !confirmPassword) {
      setMessage("Inserisci e conferma la nuova password.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("Le password non coincidono.");
      return;
    }

    if (newPassword.length < 8) {
      setMessage("La password deve avere almeno 8 caratteri.");
      return;
    }

    setSaving(true);
    try {
      const res = await fetch(`${API_URL}/api/password-reset/confirm/`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          uid,
          token,
          new_password: newPassword,
        }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.detail || "Impossibile aggiornare la password.");

      setMessage("Password aggiornata correttamente. Ora puoi accedere.");
      setTimeout(() => navigate("/login", { replace: true }), 1600);
    } catch (err) {
      setMessage(err?.message || "Errore imprevisto.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f7f1e8 0%, #ead8c8 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 460,
          background: "#fff",
          borderRadius: 22,
          padding: 32,
          boxShadow: "0 20px 60px rgba(70, 20, 20, 0.18)",
          border: "1px solid #ead8c8",
        }}
      >
        <div style={{ marginBottom: 22 }}>
          <div style={{ color: "#7a1111", fontWeight: 800, letterSpacing: 1 }}>
            Gestionale Dallo Zio Roby
          </div>
          <h1 style={{ margin: "10px 0 8px", color: "#7a1111", fontSize: 34, lineHeight: 1.05 }}>
            Imposta nuova password
          </h1>
          <p style={{ margin: 0, color: "#3f2a2a", lineHeight: 1.5 }}>
            Inserisci una nuova password personale per completare il recupero.
          </p>
        </div>

        {message && (
          <div
            style={{
              padding: "12px 14px",
              marginBottom: 16,
              borderRadius: 12,
              background: message.includes("correttamente") ? "#edf7ed" : "#fff0f0",
              color: message.includes("correttamente") ? "#1f6b2b" : "#8a1111",
              border: `1px solid ${message.includes("correttamente") ? "#bfe3c2" : "#f1b5b5"}`,
            }}
          >
            {message}
          </div>
        )}

        <form onSubmit={submit}>
          <label style={{ display: "block", marginBottom: 8, fontWeight: 700 }}>Nuova password</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            autoComplete="new-password"
            style={{
              width: "100%",
              padding: "14px 16px",
              borderRadius: 12,
              border: "1px solid #d8c5b8",
              marginBottom: 16,
              boxSizing: "border-box",
            }}
          />

          <label style={{ display: "block", marginBottom: 8, fontWeight: 700 }}>Conferma nuova password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
            style={{
              width: "100%",
              padding: "14px 16px",
              borderRadius: 12,
              border: "1px solid #d8c5b8",
              marginBottom: 22,
              boxSizing: "border-box",
            }}
          />

          <button
            disabled={saving}
            style={{
              width: "100%",
              padding: "15px 18px",
              borderRadius: 12,
              border: "none",
              background: "#8b0d12",
              color: "#fff",
              fontWeight: 800,
              cursor: saving ? "not-allowed" : "pointer",
              boxShadow: "0 10px 24px rgba(139, 13, 18, 0.25)",
            }}
          >
            {saving ? "Aggiornamento..." : "Aggiorna password"}
          </button>
        </form>
      </div>
    </div>
  );
}
